import BlankPrimaryLayout from 'src/layouts/BlankPrimaryLayout';
import { useNavigate } from 'react-router-dom';
import Spinner from 'src/components/common/designSystem/Spinner';
import { useEffect } from 'react';

// Type selection page (redirects to the select-type path for consistency)
const Onboarding = () => {
  const navigate = useNavigate();

  // Redirect to the type selection page
  useEffect(() => {
    navigate('/onboarding/select-type');
  }, [navigate]);

  return (
    <BlankPrimaryLayout>
      <div className="flex-1 flex justify-center items-center">
        <Spinner type="white" size="xl" />
      </div>
    </BlankPrimaryLayout>
  );
};

export default Onboarding;
